<template>
  <div class="new-product">
    <el-container fluid>
      <el-main>
        <el-tabs
          tab-position="right"
          @tab-click="tabChanged"
          v-model="currTabName"
        >
          <el-tab-pane label="الخزن والبنوك" color="#FE5634" name="printer">
        <div>
    <button @click="loadPrinters">Load Printers</button>

    <select v-model="printer">
      <option disabled value="">Select printer</option>
      <option v-for="p in printers" :key="p.name" :value="p.name">
        {{ p.name }}
      </option>
    </select>

    <select v-model="template">
      <option value="thermal">Thermal</option>
      <option value="a4">A4</option>
    </select>

    <button @click="print">Print</button>
  </div>
       
          </el-tab-pane>

            <el-tab-pane label="الخزن والبنوك" color="#FE5634" name="safes">
            <el-row  class="mb-5"  >
              <el-button
              width="100%"
                class="addNew mr-auto mt-3 ml-3"
                @click="openAddSafe = true"
                type="primary"
                icon="el-icon-plus"
                >إضافة خزينه</el-button
              >
          
          
</el-row>
<el-row>
            <el-table
           
              
              style="width: 60%; margin-right: 20%"
              v-if="tableData.length > 0 && !notAdmin"
              :data="tableData"
              border
            >
              <el-table-column label="#" type="index" width="50">
              </el-table-column>

              <el-table-column  label="الخزنه" prop="name">
              </el-table-column>

              <el-table-column width="150" label="الرصيد" prop="balance">
              </el-table-column>
              
            </el-table>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="تقرير الخزن " color="#FE5634" name="safeReport">
               <div class="col-md-12 row">
            <div class="col-md-3">

              <el-select
              @change="getSafeReport"
              searchable
              class="mt-2"
              v-model="selectedSafeId"
              placeholder="حدد الخزنه"
            >
              <el-option
                v-for="item in safes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </div>
  

   <div class="col-md-5 mt-2">
            <el-date-picker
              @change="getSafeReport"
              :format="format"
              :value-format="valueFormat"
              v-model="dateRange"
              type="datetimerange"
              range-separator="إلي"
              start-placeholder="بداية الفترة"
              end-placeholder="نهاية الفترة"
            >
            </el-date-picker>
            </div>
             <div class="col-md-2 mt-2" v-if="selectedSafeDetails">
 رصيد الخزينه    
      <el-button
                
                 type="warning"
                class="mr-3"
                
              > 
 
  {{ selectedSafeDetails.balance }}
              </el-button>
    
    </div>
            </div>
<el-row class="mt-5">
              <el-table
            class="mt-2"
            align="right"
            v-if="safeReport.length > 0"
            :data="safeReport"
            border
            style="width: 100%"
            height="76vh"
            v-el-table-infinite-scroll="loadMoreData"
            :infinite-scroll-disabled="disabled"
          >
            <el-table-column label="#" type="index" width="50">
            </el-table-column>
            <el-table-column label="البيان" prop="description">
            </el-table-column>
            <el-table-column width="150" label="المبلغ" prop="amount">
            </el-table-column>
           
            <el-table-column width="150" label="النوع" >
               <template slot-scope="scope">
              
                <el-tag type="success" v-if="scope.row.type == 1"
                  >ايداع 
                </el-tag>
                <el-tag type="danger" v-if="scope.row.type == 0">
                   سحب</el-tag
                >

              
              </template>
            </el-table-column>

            <el-table-column width="200" sortable label="بواسطه">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.creator.name | moment(" D/MM/YYYY | h:mm A") }}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="200" sortable label="التاريخ">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.created_at | moment(" D/MM/YYYY | h:mm A") }}
                </span>
              </template>
            </el-table-column>
 <el-table-column width="150" label="الرصيد" prop="balance">
            </el-table-column>

</el-table>

            </el-row>
          </el-tab-pane>
       
          <el-tab-pane label=" الايداع" color="#FE5634" name="safe_in">
            <el-row  class="mb-5"  >
              <el-button
              width="100%"
                class="addNew mr-auto mt-3 ml-3"
                @click="openAddInSafeModel = true"
                type="primary"
                icon="el-icon-plus"
                > تسجيل ايداع بالخزينه</el-button
              >
          
          
</el-row>
<el-row>
            <el-table
           
              
              style="width: 80%; margin-right: 10%"
              v-if="safeInReport.length > 0 && !notAdmin"
              :data="safeInReport"
              border
            >
              <el-table-column label="#" type="index" width="50">
              </el-table-column>

              <el-table-column label="الخزنه" prop="safe">
              </el-table-column>

              <el-table-column width="150"  label="المبلغ" prop="amount">
              </el-table-column>
              <el-table-column  label="الوصف" prop="description">
              </el-table-column>
              <el-table-column  label="بواسطه" prop="userName">
              </el-table-column>
              <el-table-column  label="التوقيت" prop="created_at">
              </el-table-column>
             
            </el-table>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label=" مسحوبات من الخزينه" color="#FE5634" name="safe_out">
            <el-row  class="mb-5"  >
              <el-button
              width="100%"
                class="addNew mr-auto mt-3 ml-3"
                @click="openAddOutSafeModel = true"
                type="primary"
                icon="el-icon-plus"
                > تسجيل مسحوبات من الخزينه</el-button
              >
          
          
</el-row>
<el-row>
            <el-table
           
              
              style="width: 80%; margin-right: 10%"
              v-if="safeOutReport.length > 0 && !notAdmin"
              :data="safeOutReport"
              border
            >
              <el-table-column label="#" type="index" width="50">
              </el-table-column>

              <el-table-column label="الخزنه" prop="safe">
              </el-table-column>

              <el-table-column width="150"  label="المبلغ" prop="amount">
              </el-table-column>
              <el-table-column  label="الوصف" prop="description">
              </el-table-column>
              <el-table-column  label="بواسطه" prop="userName">
              </el-table-column>
              <el-table-column  label="التوقيت" prop="created_at">
              </el-table-column>
             
            </el-table>
            </el-row>
          </el-tab-pane>
       

        </el-tabs>
      </el-main>

      <vs-dialog
     not-center="true"
        title="إضافة"
        v-model="openAddSafe"
        class="add-operation-dialog"
      >
        <!-- center -->
        <template #header>
          <span>إضافة خزنه </span>
        </template>

        <el-input
          placeholder="الاسم "
          class="mt-2"
          @focus="$event.target.select()"
          v-model="addSafeForm.name"
        ></el-input>

        <!-- This is Popup Footer -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="openAddSafe = false">إلغاء</el-button>
          <el-button type="primary" @click="addNewSafe"
            >إضافة</el-button
          >
        </span>
      </vs-dialog>
      <!-- dir="rtl" -->
      <vs-dialog
        title="إضافة"
        v-model="openAddOutSafeModel"
        width="40%"
        class="add-operation-dialog"
      >
        <!-- center -->
        <template #header>
          <span>  ايداع بالخزنه</span>
        </template>

        <el-row :gutter="10">
          
            <el-input
              class="mt-2 input1"
              placeholder="المبلغ"
              id="cost"
              type="number"
              @focus="$event.target.select()"
              v-model="outSafeForm.amount"
              controls-position="right"
              @keyup.enter.native="focusNext"
            ></el-input>
        
            <el-select
              searchable
              @focus="index = 0"
              class="mt-2"
              v-model="outSafeForm.safe_id"
              placeholder="حدد الخزنه"
              @change="focusNext"
            >
              <el-option
                v-for="item in safes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
         <div>
                <el-input
                  placeholder="حدد الوصف"
                  class="mt-2 input1"
                  @focus="$event.target.select()"
                  v-model="outSafeForm.description"
                  @keyup.enter.native="addNewCategory"
                ></el-input>
              </div>
        </el-row>
          <!-- This is Popup Footer -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="openAddOutSafeModel = false">إلغاء</el-button>
          <el-button type="primary" @click="addOutSafe"
            >إضافة</el-button
          >
        </span>
</vs-dialog>
      <vs-dialog
        title="إضافة"
        v-model="openAddInSafeModel"
        width="40%"
        class="add-operation-dialog"
      >
        <!-- center -->
        <template #header>
          <span>  ايداع بالخزنه</span>
        </template>

        <el-row :gutter="10">
          
            <el-input
              class="mt-2 input1"
              placeholder="المبلغ"
              id="cost"
              type="number"
              @focus="$event.target.select()"
              v-model="inSafeForm.amount"
              controls-position="right"
              @keyup.enter.native="focusNext"
            ></el-input>
        
            <el-select
              searchable
              @focus="index = 0"
              class="mt-2"
              v-model="inSafeForm.safe_id"
              placeholder="حدد الخزنه"
              @change="focusNext"
            >
              <el-option
                v-for="item in safes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
         <div>
                <el-input
                  placeholder="حدد الوصف"
                  class="mt-2 input1"
                  @focus="$event.target.select()"
                  v-model="inSafeForm.description"
                ></el-input>
              </div>
        </el-row>
          <!-- This is Popup Footer -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="openAddInSafeModel = false">إلغاء</el-button>
          <el-button type="primary" @click="addInSafe"
            >إضافة</el-button
          >
        </span>
</vs-dialog>
      <!-- </el-main> -->
    </el-container>

  </div>
</template>
<script>
import axiosApi from "@/plugins/axios.js";
import Item from "@/components/Item";
// import Report from "./ReportDetails.vue";

export default {
  name: "NewExpense",
  components: { Item },
  computed: {
    notAdmin() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id != 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
       printers: [],
      printer: '',
      template: 'thermal',
      // -----
      selectedSafeDetails:null,
      selectedSafeId:null,
      safeReport:[],
      outSafeForm:{},
      inSafeForm:{},
      editPartenerPayment: false,
      openAddInSafeModel: false,
      openAddOutSafeModel: false,

      format: "yyyy-MM-dd HH:mm A",
      valueFormat: "yyyy-MM-dd HH:mm:ss",

      currRecipients: {},
      showUpdateRecipients: false,
      currPartner: {},
      showUpdatePartner: false,
      currTabName: "safes",
      dateRange: localStorage.getItem("reportsInterval")
        ? JSON.parse(localStorage.getItem("reportsInterval"))
        : [
            this.$moment(new Date(), "DD-MM-YYYY")
              .locale("en")
              .format("YYYY-MM-DD") +
              " " +
              "11:30:00",
            this.$moment(new Date(), "DD-MM-YYYY")
              .add(1, "days")
              .locale("en")
              .format("YYYY-MM-DD") +
              " " +
              "11:30:00",
          ],
      addRecipient: {},
      totalExpenses: 0,
      tableData: [],
      parteners: [],
      selectedPartenerReport: [],
      selectedPartener: null,

      state: "",
      openAddRecipientsModel: false,
showDeletePartner:false,
      openAddCategoryModel: false,
      openAddModel: false,
      openAddPartenerModel: false,
      showDeleteRecipients: false,
      openAddPartenerPaymentModel: false,
      index: 0,
      false: false,
      recipients: [],

      currRecipients: {},

      categories: [],
      categoryForm: {
        name: "",
      },
      form: {
        cost: "",
        for_who: "",
        expense_category_id: null,
      },
      showConfirmModelToDeleteCategory: false,
      partenerPaymentForm: {
        id: 0,
        comment: "",
        cost: "",
        partener_id: null,
      },
        openAddSafe : false,
          addSafeForm : {},
      updateExpenseCategorie: false,
      currExpenseCategory: {},
      partenerForm: {
        name: "",
        phone: "",
      },
      safeInReport:[],
      safeOutReport:[],
      safes:[],
       pagination: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    this.getReports();

    // this.getSelectedPartenerReport(null);
  },

  mounted() {},

  methods: {
    //----- printers ------

      async loadPrinters() {
      const res = await fetch('http://localhost:3001/printers')
      this.printers = await res.json()
    },
    async print() {
      await fetch('http://localhost:3001/print', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          printerName: "this.printer",
          template: this.template,
          data: {
            invoiceNo: 'INV-001',
            items: [
              { name: 'Item A', price: 10 },
              { name: 'Item B', price: 5 }
            ],
            total: 15
          }
        })
      })
      alert('Queued for printing')
    }
  ,

    // -----
       loadMoreData() {
      this.loading = true;
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getSafeReport();
      }
    },
    getReports(){
   this.getSafes();
    this.getSafeInReport();
    this.getSafeOutReport();
    },
    goTo(path) {
      this.$router.push({ path: path });
    },
   

  
    addNewSafe() {
      const loading = this.$vs.loading();
      axiosApi
        .post(`/safes`, { ...this.addSafeForm })
        .then((res) => {
          this.$message({
            message: "تم إضافة الخزنه بنجاح",
            type: "success",
          });

          this.openAddSafe = false;
          this.addSafeForm = {};

          this.getSafes();
        })
        .finally(() => loading.close());
    },

    addInSafe() {
      const loading = this.$loading({
          lock: true,
          text: false,
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,.7)',
          customClass: 'fullscreen-loading'
        });
      axiosApi
        .post(`/safes/capital-deposit`, { ...this.inSafeForm })
        .then((res) => {
          this.$message({
            message: "تم إضافة الايداع بنجاح",
            type: "success",
          });

          this.openAddInSafeModel = false;
          this.inSafeForm= {};

          this.getSafeInReport();
        })  .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        })
        .finally(() => loading.close());
    },
    addOutSafe() {
      const loading = this.$loading({
          lock: true,
          text: false,
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,.7)',
          customClass: 'fullscreen-loading'
        });
      axiosApi
        .post(`/safes/owner-withdrawal`, { ...this.outSafeForm })
        .then((res) => {
          this.$message({
            message: "تم إضافة عمليه السحب بنجاح",
            type: "success",
          });

          this.openAddOutSafeModel = false;
          this.outSafeForm= {};

          this.getSafeOutReport();
        })  .catch((error) => {
          this.$notify({
            title: "حدث خطأ",
            message:  error.response.data.message
 ,
            type: "error",
            duration: 1500,
          });
        })
        .finally(() => loading.close());
    },

    tabChanged(tab) {
      this.getReports()
    },
    focusNext() {
      if (this.index < 3) {
        this.index += 1;
      } else {
        this.index = 1;
      }

      let input = ".input" + this.index + " input";
      console.log(input);
      setTimeout(() => {
        document.querySelector(input).focus();
      }, 100);
    },
    getSafes() {
      if (this.dateRange != null) {
        localStorage.setItem("reportsInterval", JSON.stringify(this.dateRange));

        const loading = this.$vs.loading();

        let url = `safes`;
        if (this.dateRange != null) {
          localStorage.setItem(
            "reportsInterval",
            JSON.stringify(this.dateRange)
          );

          url += `?start=${this.dateRange[0]}`;
          url += `&end=${this.dateRange[1]}`;
        }

        this.totalExpenses = 0;
        const vm = this;
        axiosApi
          .get(url)
          .then((response) => {
            this.tableData = response.data;
            this.safes = response.data;

            this.tableData.map(function (value) {
              vm.totalExpenses += value["cost"];
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    getSafeReport() {
      if(!this.selectedSafeId)return 
      if (this.dateRange != null) {
        localStorage.setItem("reportsInterval", JSON.stringify(this.dateRange));

        const loading = this.$vs.loading();

        let url = `safe-report?safe_id=${this.selectedSafeId}&page=${this.pagination.current_page}`;
        if (this.dateRange != null) {
          localStorage.setItem(
            "reportsInterval",
            JSON.stringify(this.dateRange)
          );

          url += `&start=${this.dateRange[0]}`;
          url += `&end=${this.dateRange[1]}`;
        }

        const vm = this;
        axiosApi
          .get(url)
          .then((response) => {
            // this.safeReport = response.data.logs.data;
        let openingBalance= response.data.opening_balance;
        let opening_balance= response.data.opening_balance;
           this.safeReport  = response.data.logs.data
          
           this.safeReport.map((log) => {
            
        if (log.type === 1) {
          opening_balance += log.amount
        } else {
          opening_balance -= log.amount
        }
        log.balance = opening_balance
      })
let openingLog = {
    id: null,
    operation_type_id: null,
    reference_id: null,
    type: null,
    amount: null,
    description: "الرصيد الافتتاحي ",
    from_safe_id: null,
    transfer_group_id: null,
    notes: null,
    created_by: null,
    created_at: null,
    updated_at: null,
    operation_type: null,
    creator: {name:""},
    balance: openingBalance
};

// Add to the top of the array
this.safeReport.unshift(openingLog);

console.log("this.safeReport",this.safeReport)
    
      this.selectedSafeDetails=response.data.safe;
              this.pagination.current_page = response.data.logs.current_page;
          this.pagination.last_page = response.data.logs.last_page;
           
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            loading.close();
          });
      }
    },

    getSafeInReport() {
      axiosApi
        .get("/safe-reports/capital-deposits")
        .then((res) => {
          this.safeInReport = res.data.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    getSafeOutReport() {
      axiosApi
        .get("/safe-reports/owner-withdrawals")
        .then((res) => {
          this.safeOutReport = res.data.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },

  
  },
};
</script>

<style lang="scss">
.addNew {
  padding: 7px;
}
.baby-blue-section {
  padding: 5px 18px;
  margin-bottom: 27px;
  background: #ebf9fc;
  color: #333;
  border-radius: 8px;
  margin-right: 10px;
  h6 {
    text-align: center;
  }
}
</style>
